// Lib
import React from 'react';
import { isMobile } from 'react-device-detect';
import { Typography } from '@mui/material';

// Components
import ProgressSpinner from '../../../../Spinner/ProgressSpinner';
import Button from '../../../../Button';

// Hooks
import useUser from '../../../../../hooks/useUser';

// Styles
import { useStyles } from './ProgressStyles';

const Progress = ({ onCancelUploading = () => {}, value }) => {
  const { isKiteUser } = useUser();
  const { classes } = useStyles({ isMobile, isKiteUser });

  return (
    <div className={classes.root}>
      <ProgressSpinner className={classes.spinner} value={value} />
      <Typography variant="h2" className={classes.title}>
        Uploading file...
      </Typography>
      <Button onClick={onCancelUploading} className={classes.button}>
        Cancel
      </Button>
    </div>
  );
};

export default Progress;
